import React, { useState } from 'react';
import { Box, IconButton, Slider, ClickAwayListener, Tooltip, Typography } from '@mui/material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import useScratchSize from "./useScratchSize";

const ScratchSizeControl = () => {
    const [scratchSize, setScratchSize] = useScratchSize();
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => setExpanded((prev) => !prev);
    const handleClickAway = () => {
        if (expanded) setExpanded(false);
    };

    const handleChange = (_, newValue) => {
        setScratchSize(newValue);
    };

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                    px: 0.5,
                    background: expanded ? 'linear-gradient(to right, #1c1f2a, #2d3142)' : 'transparent',
                    borderRadius: 2,
                    border: expanded ? '2px solid #3e8e93' : 'none',
                    boxShadow: expanded ? '0 0 10px rgba(122, 82, 224, 0.5)' : 'none',
                    transition: 'all 0.3s ease',
                    minWidth: expanded ? 180 : 'auto',
                }}
            >
                <Tooltip title="Adjust Scratch Size">
                    <IconButton onClick={toggleExpanded} size="small">
                        <CleaningServicesIcon sx={{ color: '#b4a0eb' }} />
                    </IconButton>
                </Tooltip>

                {expanded && (
                    <Box sx={{ ml: 1, mr: 2 }}>
                        <Slider
                            value={scratchSize}
                            min={5}
                            max={100}
                            step={1}
                            onChange={handleChange}
                            valueLabelDisplay="auto"
                            sx={{
                                width: 120,
                                color: '#b4a0eb',
                                '& .MuiSlider-thumb': {
                                    backgroundColor: '#fff',
                                    border: '2px solid #b4a0eb',
                                },
                                '& .MuiSlider-track': {
                                    backgroundColor: '#b4a0eb',
                                },
                                '& .MuiSlider-rail': {
                                    backgroundColor: '#333',
                                },
                            }}
                        />
                        <Typography
                            variant="caption"
                            sx={{
                                color: '#ccc',
                                textAlign: 'center',
                                display: 'block',
                                mt: -1,
                            }}
                        >
                            Scratcher Size
                        </Typography>
                    </Box>
                )}
            </Box>
        </ClickAwayListener>
    );
};

export default ScratchSizeControl;
